import { MedicareAgentCollection } from '@/consent/medicare/domain/MedicareAgentCollection';
import { MedicareSettingsRepository } from '@/consent/medicare/domain/MedicareSettingsRepository';
import { UseCase } from '@/shared/application/UseCase';

export class MedicareSettingsUseCase implements UseCase<null, MedicareAgentCollection> {

  private repository: MedicareSettingsRepository;

  public constructor (repository: MedicareSettingsRepository) {
    this.repository = repository;
  }

  public async run (): Promise<MedicareAgentCollection> {
    return await this.repository.getAgents();
  }

}
